import React from 'react';
import image from 'assets/images/100-10-1-welcome5.jpg';
import { RHP } from 'providers';
import { useCXI } from 'modules/cxi/useCXI';
import { Button } from 'modules/cxi/components/button';
import * as Styled from '../StyledCXIWelcomeModal';
import { useCXISetup } from '../../useCXISetup';
import ProgressBar from '../components/ProgressBar';

export const CXIWelcomeStep5 = props => {
    const { t } = useCXI();
    const { vars } = useCXISetup();

    const handleClick = () => {
        RHP.push('/100-10-1/setup/1');
    };

    let buttonText = t('setup.index.start');
    if (vars.isEditing) {
        buttonText = t('setup.index.edit');
    }

    return (
        <Styled.CxiModal>
            <Styled.CXISetupIndexCard>
                <Styled.Image>
                    <img src={image} alt="Logo 100-10-1" />
                </Styled.Image>

                <Styled.Title>{t('setup.welcome.step5.title')}</Styled.Title>
                <Styled.Descr> {t('setup.welcome.step5.descr')}</Styled.Descr>
                <ProgressBar current={5} />
                <Button size="large" variant="default" onClick={handleClick} className="nextButton">
                    {buttonText}
                </Button>
            </Styled.CXISetupIndexCard>
        </Styled.CxiModal>
    );
};
